<input type="text" class="form-control" [(ngModel)]="empID" placeholder="Enter EmployeeId" (input)="onInput($event)"> 
<button type="button" class="btn btn-warning btn-sm" (click)="searchEmp()">Search</button>